import React from 'react'
import useItems from '../../../hooks/use-durations'
import { find } from 'lodash'

const LabelItem = ({ durationId }) => {
    const [ durations ] = useItems()
    const item = find(durations, { id: durationId })
    const name = item ? item.name : ''
    return (
        <React.Fragment>{name}</React.Fragment>
    )
}

export default LabelItem